import React, { ReactChild } from 'react';

const IcGrayInfo: () => ReactChild = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 10a7.5 7.5 0 1 1 15 0 7.5 7.5 0 1 1-15 0ZM10 1.25A8.75 8.75 0 0 0 1.25 10 8.75 8.75 0 0 0 10 18.75 8.75 8.75 0 0 0 18.75 10 8.75 8.75 0 0 0 10 1.25Zm-.006 4.063a.934.934 0 0 0-.931.937c0 .518.417.938.93.938h.013c.514 0 .931-.42.931-.938a.934.934 0 0 0-.93-.938h-.013ZM8.125 8.124h2.5v5H12.5v1.25h-5v-1.25h1.875v-3.75h-1.25v-1.25Z"
      fill="#1F1F1F"
      fillOpacity={0.35}
    />
  </svg>
);

export default IcGrayInfo;
